module.exports = __webpack_public_path__ + "static/media/pic.fw.f59df85d.png";